module.exports = __webpack_public_path__ + "img/image_not_available.adcaab3f.jpg";